import analyticService from '../../services/analytics';
import mixin from '../../mixins/mixin';
import Multiselect from 'vue-multiselect';

export default {
  data() {
    return {
      analysis: {
        year: (new Date()).getFullYear(),
        email: this.email,
        rental_id: [], // id not ids because on mobile we have id.
      },
      hold_eventLoading: false,
      value: [],
      options: [

      ],
    };
  },
  props: {
    rentals: Array,
    email: String,
    groups: Array,
  },
  components: {
    VLoading: require('components/loading/loading.vue'),
    VMultiselect: Multiselect,
  },
  mixins: [mixin],
  mounted() {
    this.analysis.email = this.email;
  },
  methods: {
    async exportAnalysis() {
      if (this.rentals && this.rentals.length > 0) {
        this.openModal('#export-analysis-modal');
      } else {
        toastr.error(this.$t('rentals.index.no_result'));
      }
    },
    selectRental(rental) {
      this.value = rental;
    },
    async downloadMyExport() {
      const vm = this;
      vm.hold_eventLoading = true;
      this.value.map(val => this.analysis.rental_id.push(val.id));
      await analyticService.generateAnalyticsCsv(vm, vm.analysis);
      this.value = [];
    },
    closeExportAnalysisModal(modalName) {
      this.analysis = {
        email: this.email,
        rental_ids: '',
        year: (new Date()).getFullYear(),
      };
      this.analysis.rental_id = [];
      this.value = [];
      this.closeModal(modalName);
    },

    generateGroups() {
      this.options = [];
      this.groups.forEach((group) => {
        const option = {
          language: '',
          libs: [],
        };
        option.language = group.name === 'others' ? this.$t('groups.others') : group.name;
        group.rentals.forEach((item) => {
          option.libs.push({ name: item.name, id: item.id });
        });
        this.options.push(option);
      });
    },
  },
  watch: {
    groups(newValue) {
      if (newValue.length) {
        this.generateGroups();
      }
    },
    email(newValue) {
      this.analysis.email = newValue;
    },
    getAccount(newValue, oldValue) {
      if (oldValue !== newValue) {
        this.generateGroups();
      }
    },
  },
  computed: {
    getAccount() {
      return this.$store.getters.account.lang;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/export-analysis/export-analysis.js